module.exports = __webpack_public_path__ + "static/media/ellipsisH.964427f5.svg";